export enum FileSource {
  Files = 'files',
  Templates = 'templates',
}
